<template>
  <div id="app">
    <TheHeader />
    <main>
      <HeroSection />
      <ProductsSection />
      <SolutionsSection />
      <WhySection />
      <AboutSection />
      <PartnersSection />
      <NewsSection />
      <ContactSection />
    </main>
    <TheFooter />

    <transition name="fade">
      <button v-show="showTop" class="to-top" :aria-label="$t('common.backToTop')" @click="scrollTop">↑</button>
    </transition>
  </div>
</template>

<script>
import TheHeader from './components/TheHeader.vue'
import HeroSection from './components/HeroSection.vue'
import ProductsSection from './components/ProductsSection.vue'
import SolutionsSection from './components/SolutionsSection.vue'
import WhySection from './components/WhySection.vue'
import AboutSection from './components/AboutSection.vue'
import PartnersSection from './components/PartnersSection.vue'
import NewsSection from './components/NewsSection.vue'
import ContactSection from './components/ContactSection.vue'
import TheFooter from './components/TheFooter.vue'

export default {
  name: 'App',
  components: {
    TheHeader, HeroSection, ProductsSection, SolutionsSection, WhySection,
    AboutSection, PartnersSection, NewsSection, ContactSection, TheFooter
  },
  data() {
    return { showTop: false }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() { this.showTop = window.scrollY > 600 },
    scrollTop() { window.scrollTo({ top: 0, behavior: 'smooth' }) }
  }
}
</script>

<style>
#app { position: relative; }

.to-top {
  position: fixed; bottom: 28px; right: 28px; z-index: 90;
  width: 50px; height: 50px; border-radius: 14px; border: 1px solid var(--ec-line);
  background: var(--ec-grad); color: #04101f; font-size: 22px; font-weight: 800;
  box-shadow: 0 14px 36px -12px rgba(255,153,0,.7);
  transition: transform .25s ease;
}
.to-top:hover { transform: translateY(-3px); }

.fade-enter-active, .fade-leave-active { transition: opacity .3s ease, transform .3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(10px); }
</style>
